import React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import StepReview from "./StepReview";
import FooterButtonView from "./FooterButtonView";

function formatDate(dateStr) {
  if (!dateStr) return "-";
  const d = new Date(dateStr);
  if (isNaN(d)) return "-";
  return d.toLocaleDateString() + " " + d.toLocaleTimeString();
}

export default function StatusModal({ isOpen, handleClose, retestRequest, onCreateRetest, onCancelRequest }) {
  return (
    <Modal isOpen={isOpen} toggle={() => handleClose(null)} centered size="lg">
      <ModalHeader toggle={() => handleClose(null)}>
        Retest Order
      </ModalHeader>
      <ModalBody>
        <div style={{ height: 470, overflowY: "auto", overflowX: "hidden", width: "100%" }}>
          <div className="mb-3">
            <div className="d-flex mb-2">
              <span><strong>Submission date:</strong></span>
              <span className="ms-2">
                {formatDate(retestRequest?.createdAt)}
              </span>
            </div>
            <div className="d-flex mb-2">
              <span><strong>Activation date:</strong></span>
              <span className="ms-2">
                {formatDate(retestRequest?.activatedAt)}
              </span>
            </div>
            <div className="d-flex mb-2">
              <span><strong>Retest kit sample code:</strong></span>
              <span className="ms-2">
                {retestRequest?.sampleIdForRetest || "-"}
              </span>
            </div>
            {retestRequest?.cancellationReason && <div className="d-flex mb-2">
              <span><strong>Cancellation reason:</strong></span>
              <span className="ms-2">
                {retestRequest?.cancellationReason}
              </span>
            </div>
            }
          </div>
          <StepReview
            selectedBiomarkers={retestRequest?.biomarkers || []}
            selectedType={retestRequest?.tube}
          />
        </div>
      </ModalBody>
      <ModalFooter>
        <FooterButtonView
          onClose={handleClose}
          status={retestRequest?.status}
          onNext={onCreateRetest}
          onCancelRequest={onCancelRequest}
        />
      </ModalFooter>
    </Modal>
  );
}
